import { ChangeDetectorRef, Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { filter } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { SimpleTableComponent } from '../../generals/Components';
import { BlogItem } from '../../interfaces/interfaces';
import { BlogeditorComponent } from '../blogeditor/blogeditor.component';
import { BlogdeleteComponent } from '../blogdelete/blogdelete.component';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.scss']
})
export class BlogsComponent extends SimpleTableComponent<BlogItem> {

  showBlogEditorModal(blogItem: BlogItem = null): void {
    this.dialogService.open(BlogeditorComponent, {
      header: blogItem !== null ? 'Blog bejegyzés szerkesztése - ' + blogItem.title : 'Blog bejegyzés hozzáadása',
      data: {
        blogId: blogItem !== null ? blogItem.blogId : null
      }
    }).onClose.pipe(filter(v => v === true)).subscribe(() => {
      this.refreshTable();
    });
  }

  showBlogDeleteModal(blogItem: BlogItem = null): void {
    this.dialogService.open(BlogdeleteComponent, {
      header: 'Blog bejegyzés törlése - ' + blogItem.title,
      data: {
        blogId: blogItem.blogId
      }
    }).onClose.pipe(filter(v => v === true)).subscribe(() => {
      this.refreshTable();
    });
  }

  constructor(
    private apiServiceRef: ApiService,
    private dialogService: DialogService,
    private changeDetectionRef: ChangeDetectorRef
  ) {
    super(changeDetectionRef, apiServiceRef);
    this.endPoint = 'blogs';
  }
}
